export type MobileSelectMode = 'select' | 'add';

export interface MobileSelectActionInput<T> {
    option: T;
    isSelected: boolean;
    disableClearable?: boolean;
    mode: MobileSelectMode;
}

export interface MobileSelectAction<T> {
    nextValue: T | null | undefined;
    shouldClose: boolean;
    shouldClearSearch: boolean;
}

export function getMobileSelectAction<T>({
    option,
    isSelected,
    disableClearable = false,
    mode,
}: MobileSelectActionInput<T>): MobileSelectAction<T> {
    if (mode === 'add') {
        return {
            nextValue: option,
            shouldClose: false,
            shouldClearSearch: true,
        };
    }

    if (isSelected) {
        if (disableClearable) {
            return {
                nextValue: undefined,
                shouldClose: true,
                shouldClearSearch: false,
            };
        }

        return {
            nextValue: null,
            shouldClose: false,
            shouldClearSearch: false,
        };
    }

    return {
        nextValue: option,
        shouldClose: true,
        shouldClearSearch: false,
    };
}

export function getMobileDrawerZIndex(zIndex: { drawer: number; modal: number }): number {
    return Math.max(zIndex.drawer, zIndex.modal) + 1;
}
